
import MonitorUserStatList from './monitorUserStatList';
import { Place  } from '@material-ui/icons';
// 각 지역 큰 틀 컴포넌트
const MonitorUserStatArea = ({dongCode , dongTerm , dataSource}) => {
  // 유저 리스트 필터링
  const userList = dataSource.filter( v => v.fixbylawBundCode === dongCode);
  return(
    <div className="uk-width-medium-1-4">
      <div className="md-card">
        <div className="md-card-content DAFourBottom">
          <div className="md-card-toolbar">
              <h3 className="md-card-toolbar-heading-text"><Place className="material-icons"/>{dongTerm}</h3>
          </div>
          <MonitorUserStatList dataSource = {userList} />
        </div>
      </div>
    </div>
  )
}

export default MonitorUserStatArea;